/**
 * Game details: each label with its value (venue and TV before a game,
 * ISSUE-988; attendance in game, ISSUE-989). Rendered as sent. ISSUE-988 WI-25.
 */
import type { ReactNode } from "react";

import type { typeDetailRow } from "./matchupTypes";
import { GameSectionCard } from "./GameSectionCard";

export const DetailsSection = ({
  title,
  rows,
}: {
  title: string;
  rows: readonly typeDetailRow[];
}): ReactNode => (
  <GameSectionCard testId="matchup-details" title={title}>
    <dl className="flex flex-col">
      {rows.map((row) => (
        <div
          key={row.key}
          className="flex min-h-touch-target items-center justify-between gap-2 border-t border-hairline text-body first:border-t-0"
        >
          <dt className="text-ink-secondary">{row.label}</dt>
          <dd className="text-ink">{row.value}</dd>
        </div>
      ))}
    </dl>
  </GameSectionCard>
);
